<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createFilesComConfig } from "./fs";
  import { filesComSite, makeFileSystemFilesCom, testFilesComConnection } from "./fs-filescom";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createFilesComConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing files.com connection");
    try {
      config.apiKey = config.apiKey.trim();
      config.site = filesComSite(config.site);
      config.name = config.name.trim();
      await testFilesComConnection(config);
      if (config.name == "") {
        config.name = config.site || "Files.com";
      }
      let fs = makeFileSystemFilesCom(config);
      let who = config.site || "default site";
      telegramNotify(`New Files.com connection for ${who}`);
      captureEvent("filescom-login", {});
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Files.com">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-filescom-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-filescom-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-filescom-site">Site: <span class="text-gray-400">(optional)</span></label>
      <input
        type="text"
        id="input-filescom-site"
        autocomplete="off"
        placeholder="mysite or files.example.com"
        class="outline-hidden border px-2 py-1"
        bind:value={config.site}
      />

      <label class="mt-3" for="input-filescom-key">API key:</label>
      <input
        type="password"
        id="input-filescom-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-3 w-72 text-gray-500">
        The site is your subdomain of files.com or your custom domain. Make an API key in the Files.com web interface,
        under your user's settings.
      </div>

      {#if errorMessage}
        <div class="mt-2 mb-2 w-72 font-medium break-all text-red-500">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Files.com</button>
    </div>
  {/snippet}
</DialogBase>
